// extracted by mini-css-extract-plugin
export default {"layout":"AuthLayout_layout__MO9d4","modal":"AuthLayout_modal__Nkppc","logo":"AuthLayout_logo__IR20C","title":"AuthLayout_title__bGIaq","desc":"AuthLayout_desc__ycVnW"};